export default "__VITE_ASSET__CbL_zA6u__"